import styled, { css } from 'styled-components';
import { ifNotProp, ifProp } from 'styled-tools';

import { maxWidth, minWidth } from '@calm-web/design-system';

import MainContent from '@/components/accessibility/MainContent';

export const PageWrap = styled(MainContent)<{ isWithinModal?: boolean; isCompact?: boolean }>`
	${ifNotProp(
		'isWithinModal',
		css`
			padding-top: 40px;
		`,
	)}

	${props =>
		!props.isCompact &&
		css`
			min-height: calc(100vh - 40px);
		`}

    ${maxWidth('tablet')} {
		padding-top: 0;

		> div {
			padding: 20px;
			${ifProp('isWithinModal', 'padding: 0;')}
			${ifProp('isWithinModal', 'margin: 20px;')}
		}
	}
`;

export const TwoColumnWrapper = styled.div<{ isWithinModal?: boolean }>`
	display: flex;
	flex-direction: ${ifProp('isWithinModal', 'column-reverse', 'column')};
	align-items: center;
	padding: ${ifProp('isWithinModal', '0px', '20px')};

	${minWidth('desktop')} {
		flex-direction: row-reverse;
		justify-content: space-evenly;
		align-items: flex-start;
		max-width: 1440px;
		margin: auto;
		gap: 80px;
		min-height: inherit;
		padding: 0 20px;
	}
`;

export const ValuePropsListWrapper = styled.div<{
	showHeader?: boolean;
	isWithinModal?: boolean;
}>`
	text-align: center;
	width: 100%;

	${minWidth('tablet')} {
		margin-top: ${ifProp('showHeader', 0, ifProp('isWithinModal', 0, '110px'))};
	}

	${minWidth('desktop')} {
		max-width: 420px;
	}

	h3 {
		text-align: center;
	}
`;
